module.exports = __webpack_public_path__ + "img/match-create-unit.17297be6.png";